module.exports = __webpack_public_path__ + "img/ic_services_cleaner.69316ca0.svg";